import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6;
import { GRID_MAX_WIDTH } from "../../../constants/design";
import mediaQueries, { cssForBreakpointsConfig } from "../../../util/mediaqueries";
import { spacing } from "../../../util/spacing";
import styled, { css } from 'styled-components';
import { getGridPositionsFor } from "./helpers";
var Grid = styled.div.withConfig({
  componentId: "sc-1guhp6n-0"
})(["display:grid;margin:auto;grid-template-columns:repeat(4,1fr);gap:", ";padding-right:", ";padding-left:", ";", ";", ";", ";", ";", " ", ""], spacing(2), spacing(2), spacing(2), mediaQueries.xs(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    grid-template-columns: repeat(8, 1fr);\n    gap: ", ";\n    padding-right: ", ";\n    padding-left: ", ";\n  "])), 0, 0, 0)), spacing(3), spacing(3), spacing(3)), mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-template-columns: repeat(12, 1fr);\n    gap: ", ";\n    padding-right: ", ";\n    padding-left: ", ";\n  "])), 0, 0, 0)), spacing(3), spacing(3), spacing(3)), mediaQueries.lg(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-template-columns: repeat(12, 1fr);\n    gap: ", ";\n    padding-right: ", ";\n    padding-left: ", ";\n  "])), 0, 0, 0)), spacing(3), spacing(5), spacing(5)), mediaQueries.xl(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    grid-template-columns: repeat(12, 1fr);\n    gap: ", ";\n    padding-right: ", ";\n    padding-left: ", ";\n    max-width: ", "px;\n  "])), 0, 0, 0, 0)), spacing(4), spacing(6), spacing(6), GRID_MAX_WIDTH), function (_ref) {
  var rows = _ref.rows;
  if (!rows) {
    return;
  }
  if (typeof rows === 'number') {
    return "grid-template-rows: repeat(".concat(rows, ", 1fr);");
  }
  if (typeof rows === 'string') {
    return "grid-template-rows: ".concat(rows, ";");
  }
  return cssForBreakpointsConfig(rows)(_t5 || (_t5 = _(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      ", "\n    "])), 0)), function (rowForBreakpoint) {
    if (typeof rowForBreakpoint === 'number') {
      return "grid-template-rows: repeat(".concat(rowForBreakpoint, ", 1fr);");
    }
    return "grid-template-rows: ".concat(rowForBreakpoint, ";");
  });
}, function (_ref2) {
  var template = _ref2.template;
  if (!template) {
    return;
  }
  if (typeof template === 'string') {
    return "grid-template-areas: ".concat(template, ";");
  }
  return cssForBreakpointsConfig(template)(_t6 || (_t6 = _(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      grid-template-areas: ", ";\n    "])), 0)), function (templateAreaForBreakpoint) {
    return templateAreaForBreakpoint;
  });
});
export var GridItem = styled.div.withConfig({
  componentId: "sc-1guhp6n-1"
})(["", ""], function (_ref3) {
  var column = _ref3.column,
    row = _ref3.row,
    area = _ref3.area;
  return css(["", " ", " ", ""], column && getGridPositionsFor('column', column), row && getGridPositionsFor('row', row), area && "grid-area: ".concat(area, ";"));
});
export default Grid;